<template>
	<Col>
		<h5 class="active-status">
			Group status:
			<span v-if="isSyncActive" class="ml-1">
				<v-icon color="success" x-small>mdi-check-circle</v-icon>
				Active
			</span>
			<span v-else class="ml-1">
				<v-icon color="orange" x-small>mdi-alert-circle</v-icon>
				Deactivated
			</span>
		</h5>
		<h5 class="sync-time">{{ lastSyncedText }}</h5>
	</Col>
</template>

<script>
export default {
	name: 'GroupHeadingSyncStatus',
	props: {
		isSyncActive: { type: Boolean },
		lastSyncedText: { type: String },
	},
};
</script>

<style scoped lang="scss">
.sync-time {
	color: var(--secondary-font-color);
}
</style>
